import { BookingPage as BookingComponent } from '../components/BookingPage';
import { useNavigate, useLocation } from 'react-router-dom';

export function BookingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get preSelectedService and isPaidSession from state passed during navigation
  const preSelectedService = location.state?.preSelectedService;
  const isPaidSession = location.state?.isPaidSession || false;

  const handleNavigateToHome = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToServices = () => {
    navigate('/services');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <BookingComponent 
      onNavigateToHome={handleNavigateToHome}
      onNavigateToServices={handleNavigateToServices}
      preSelectedService={preSelectedService}
      isPaidSession={isPaidSession}
    />
  );
}
